import { useState, type FormEvent } from 'react';
import { useAuth } from '../state/auth';
import { Champ } from '../components/ui';
import { API_BASE, definirApi } from '../api/config';

export default function Connexion() {
  const { connexion } = useAuth();
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [envoi, setEnvoi] = useState(false);

  async function soumettre(e: FormEvent) {
    e.preventDefault();
    setErreur(''); setEnvoi(true);
    try { await connexion(email, motDePasse); }
    catch (err) { setErreur(err instanceof Error ? err.message : 'Connexion impossible'); }
    finally { setEnvoi(false); }
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', minHeight: '100vh' }}>
      <div style={{ background: 'linear-gradient(160deg,#0F1B2D,#16233A)', color: '#fff', padding: '56px 48px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 30, fontWeight: 800, letterSpacing: 3 }}>FRIENDS<span style={{ color: 'var(--accent)' }}>.</span></div>
          <div style={{ fontSize: 12, letterSpacing: 5, opacity: .65, marginTop: 2 }}>LOCATION</div>
          <p style={{ marginTop: 8, opacity: .8, fontSize: 15 }}>Location de véhicules — Gestion d'agence</p>
        </div>
        <p style={{ fontSize: 22, lineHeight: '32px', fontWeight: 600, maxWidth: 420 }}>
          Vos règles ne sont plus seulement écrites au dos du contrat.<br />
          <span style={{ color: 'var(--accent)' }}>Elles sont appliquées.</span>
        </p>
        <div style={{ fontSize: 12, opacity: .55 }}>RC 16 / 00 - 1203856 B 23 · SEFSAPHA AIN NAADJA</div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32, background: '#fff' }}>
        <form onSubmit={soumettre} style={{ width: 'min(380px,100%)', display: 'grid', gap: 16 }}>
          <div>
            <h1 style={{ fontSize: 26 }}>Connexion</h1>
            <p className="sourdine mini" style={{ marginTop: 4 }}>Identifiez-vous pour accéder à votre poste.</p>
          </div>
          {erreur && <div className="bandeau ko"><div>{erreur}</div></div>}
          <Champ label="Adresse e-mail">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required autoFocus />
          </Champ>
          <Champ label="Mot de passe">
            <input type="password" value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} autoComplete="current-password" required />
          </Champ>
          <button className="btn btn-p btn-l btn-bloc" disabled={envoi}>{envoi ? 'Connexion…' : 'Se connecter'}</button>
          {/* Jamais en production : cette page est publique, et afficher trois
              adresses réelles avec leur mot de passe partagé revient à donner
              les clés de la caisse. */}
          {import.meta.env.DEV && (
            <p className="mini sourdine" style={{ textAlign: 'center', marginTop: 4 }}>
              Démonstration : hichem@ / reda@ / sabrina@friends-location.com — <b>friends2026</b>
            </p>
          )}

          {/* Sans nom de domaine, l'adresse du serveur change a chaque redemarrage
              du tunnel. On la rend modifiable ici plutot que de reconstruire le site. */}
          <details style={{ marginTop: 6 }}>
            <summary className="mini sourdine" style={{ cursor: 'pointer', textAlign: 'center' }}>
              Serveur : {API_BASE || 'même origine'}
            </summary>
            <div style={{ marginTop: 8 }}>
              <Champ label="Adresse du serveur" aide="Collez l'adresse du serveur, puis appuyez sur Entrée.">
                <input defaultValue={API_BASE} placeholder="https://xxx.trycloudflare.com"
                       onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); definirApi((e.target as HTMLInputElement).value); } }} />
              </Champ>
            </div>
          </details>
        </form>
      </div>
    </div>
  );
}
